<template>
  <layout class="mt-10">
    <h1 class="header-text text-center">Private Browsing Detected</h1>
    <p class="mb-5 text-dark-gray md:mb-5">
      You're using Private Browsing mode in {{ browserName }}, which restricts
      certain functionalities on our platform.
    </p>
    <p class="mb-6">
      To continue, please disable Private Browsing mode and ensure cookies are
      allowed in your browser settings.
    </p>
  </layout>
</template>

<script>
import Layout from '@/components/layouts/HoldingTankLayout.vue';
import { detectIncognito } from 'detectincognitojs';

export default {
  name: 'Private Browsing Detected',
  components: {
    Layout,
  },
  data() {
    return {
      browserName: null,
    };
  },
  mounted() {
    detectIncognito().then((result) => {
      this.browserName = result.browserName;
    });
  },
};
</script>
<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-6 text-dark-blue md:mb-8;
}
</style>
